import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import "../styles/search.css";
import { API_BASE_URL, BASE_URL } from "../api/api";

const SearchPage = () => {
  const navigate = useNavigate();

  const { addToCart } = useCart();

  const [query, setQuery] = useState("");

  const [menuItems, setMenuItems] = useState([]);

  const [filteredItems, setFilteredItems] = useState([]);

  const [recent, setRecent] = useState([]);

  const [loading, setLoading] = useState(true);

  // FETCH ITEMS

  useEffect(() => {
    fetchItems();

    const storedRecent =
      JSON.parse(localStorage.getItem("recentSearches")) || [];

    setRecent(storedRecent);
  }, []);

  const fetchItems = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/menu-items`);

      const data = await response.json();

      setMenuItems(data);

      setFilteredItems(data);
    } catch (error) {
      console.error("Search fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  // SEARCH

  useEffect(() => {
    if (!query.trim()) {
      setFilteredItems(menuItems);

      return;
    }

    const filtered = menuItems.filter((item) =>
      item.item_name?.toLowerCase().includes(query.toLowerCase()),
    );

    setFilteredItems(filtered);

    // SAVE RECENT

    const timeout = setTimeout(() => {
      saveRecent(query);
    }, 500);

    return () => clearTimeout(timeout);
  }, [query, menuItems]);

  // SAVE RECENT

  const saveRecent = (text) => {
    if (!text.trim()) return;

    let updated = [
      text,
      ...recent.filter((item) => item.toLowerCase() !== text.toLowerCase()),
    ];

    updated = updated.slice(0, 6);

    setRecent(updated);

    localStorage.setItem("recentSearches", JSON.stringify(updated));
  };

  // ADD TO CART

  const handleAddToCart = (item, e) => {
    e.stopPropagation();

    addToCart(item, 1);

    alert(`${item.item_name} added to cart`);
  };

  return (
    <main className="search-page">
      {/* SEARCH HEADER */}

      <div className="search-header">
        <div className="search-box">
          <span className="search-icon">🔍</span>

          <input
            type="text"
            placeholder="Search for food..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
      </div>

      {/* RECENT */}

      {recent.length > 0 && !query && (
        <div className="recent-box">
          <h4>Recent Searches</h4>

          <div className="recent-list">
            {recent.map((item, i) => (
              <span key={i} onClick={() => setQuery(item)}>
                {item}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* LOADING */}

      {loading ? (
        <div className="search-loading">
          <div className="loader"></div>

          <p>Searching delicious food...</p>
        </div>
      ) : (
        <div className="product-grid">
          {filteredItems.length > 0 ? (
            filteredItems.map((item) => (
              <div
                className="product-card"
                key={item.id}
                onClick={() => navigate(`/item/${item.id}`)}>
                <div className="product-image">
                  <img
                    src={
                      item.image
                        ? `${BASE_URL}/${item.image}`
                        : "https://cdn-icons-png.flaticon.com/512/5787/5787016.png"
                    }
                    alt={item.item_name}
                    onError={(e) => {
                      e.target.src =
                        "https://cdn-icons-png.flaticon.com/512/5787/5787016.png";
                    }}
                  />
                </div>

                <div className="product-info">
                  <h5>{item.item_name}</h5>

                  <p className="desc">
                    {item.description || "Delicious food item"}
                  </p>

                  <div className="bottom-row">
                    <span>₹{item.price}</span>

                    <button onClick={(e) => handleAddToCart(item, e)}>
                      Add
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-result">
              <h3>No food found 😢</h3>

              <p>Try another search keyword</p>
            </div>
          )}
        </div>
      )}
    </main>
  );
};

export default SearchPage;
